import { T } from 'components/Translations';
import { ApiUrl, AppPages } from 'project/Defines.js';
import { Project } from 'project/Project';
import { dispatchCustomEvent, EVENT_NAME } from 'project/utilities';
import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import DetailView from 'Shared/DetailView';
import { FormField } from 'Shared/Form/formFields.js';
import useDetail from 'Shared/useDetail';
import { ValidationDropDownValueList, ValidationInput } from '~/Shared/Form/validation';


/**
 * the CoverageDetails and main data of CoverageDetails
 * @exports CoverageDetails
 */
export default function CoverageDetails(props) {
    const { id } = useParams();
    const reseau_uuid = new URLSearchParams(props.location.search).get("reseau_uuid");
    const { windowKey, data, onDelete } = props;
    const [tabIndex] = useState(0);
    const listUpdateEvent = EVENT_NAME.COVERAGE_LIST_UPDATE;

    const { isNew, dataItem, setDataItem, updateData, onChangeData, closePopup, onDetailDelete, detailRef, validation } = useDetail({
        data: data || { ID: id !== "create" ? id : null },
        updateUrl: ApiUrl.CoverageUpdate,
        windowKey,
        dataLoadUrl: ApiUrl.CoverageLoad,
        onLoadData: (response, setDataItem) => {
            if (!response.ID) {
                setDataItem({ ...response, reseau_uuid });
                return true;
            }
        },
        // nameField: 'code',
        deleteUrl: ApiUrl.CoverageDelete,
        backPage: AppPages.Coverage,
        listUpdateEvent,
        detailUrl: Project.getPageUrl(AppPages.CoverageDetails),
        validationFields: ['reseau_uuid', 'coverage', 'business_unit', 'template_code', 'coverage_value']
    });

    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
        }
        dispatchCustomEvent(listUpdateEvent, { action: 'update' });
        closePopup();
    }, [setDataItem, closePopup, detailRef, listUpdateEvent]);

    return (<>
        {dataItem && <DetailView
            backUrl={Project.getPageUrl(AppPages.Coverage)}
            title={isNew ? <T>text.new_coverage</T> : <T>text.edit_coverage</T>}
        >
            <form>
                <div className='form_container'>
                    <div className='section_group'>
                        <div className='sections '>
                            <FormField label="text.sales_network">
                                <ValidationDropDownValueList
                                    name="reseau_uuid"
                                    value={dataItem.reseau_uuid}
                                    validation={validation}
                                    valuelist="reseaux"
                                    onChange={(e) => { onChangeData({ target: { name: "reseau_uuid", value: e } }); }} // NOSONAR
                                    searchOptions={{
                                        noAccent: true,
                                        contains: true
                                    }}
                                    disabled={true}
                                />
                            </FormField>
                            <FormField label="text.coverage">
                                <ValidationDropDownValueList
                                    name="coverage"
                                    value={dataItem?.coverage}
                                    validation={validation}
                                    valuelist="coverage_types"
                                    //onChange={(e) => changeLevelValue(e)} // NOSONAR
                                    onChange={(e) => { onChangeData({ target: { name: "coverage", value: e } }); }}
                                    searchOptions={{
                                        noAccent: true,
                                        contains: true
                                    }}
                                />
                            </FormField>
                        </div>
                        <div className='sections '>
                            <FormField label="text.business_unit">
                                <ValidationInput 
                                    validation={validation}
                                    name='business_unit'
                                    type='text'
                                    value={dataItem?.business_unit}
                                    onChange={onChangeData} />
                            </FormField>
                            <FormField label="text.template">
                                <ValidationInput 
                                    validation={validation}
                                    name='template_code'
                                    type='text'
                                    value={dataItem?.template_code}
                                    onChange={onChangeData} />
                            </FormField>
                            <FormField label="text.value">
                                <ValidationInput
                                    validation={validation}
                                    name='coverage_value'
                                    type='text'
                                    value={dataItem?.coverage_value}
                                    onChange={onChangeData}/>
                            </FormField>
                        </div>
                    </div>
                </div>
                {tabIndex < 2 &&
                    <toolbar>
                        <wrap>
                            <action right=''>
                                <div onClick={(e) => updateData(updateSuccessCallback)} className='button'><icon>save</icon><T>text.save</T></div>
                                {dataItem.ID &&
                                    <div className='button' onClick={(e) => {
                                        (onDelete && onDelete(dataItem, closePopup)) ||
                                            onDetailDelete(dataItem)
                                    }}>
                                        <icon>delete</icon><T>text.delete</T>
                                    </div>}
                            </action>
                        </wrap>
                    </toolbar>}
            </form>
        </DetailView>}
    </>);
}
